export const SURVEY_EDITOR_PATH = "/surveys-editor/:surveyId/:tab?";
